import store from '../../../../store/store';
import { ActionStatus } from '../../../../common/constants/action-status';
import { StoreState } from '../../../../store/store.interface';
import { getLoadPaypalSdkStatus } from '../../braintree';
import { isLoadingBraintreeDependencies } from '../../utils/braintree.util';

/**
 * This function can only be used where are the Paypal component on the page.
 */
export function isLoadingPaypalDependencies() {
  const state = store.getState() as StoreState;
  const loadingBraintree = isLoadingBraintreeDependencies();
  if (!loadingBraintree) {
    return false;
  }

  const paypalSdkStatus = getLoadPaypalSdkStatus(state);

  return isLoadingPaypalSdk(paypalSdkStatus);
}

/**
 * Checks if Paypal sdk is loading.
 *
 * @param paypalSdkStatus
 */
function isLoadingPaypalSdk(paypalSdkStatus: ActionStatus) {
  return paypalSdkStatus === ActionStatus.loading;
}
